<template>
  <div :class="$style.container">
    <div :class="[$style['spacing-' + spaceBetween], $style['left-' + ratio]]">
      <slot></slot>
    </div>
    <div :class="$style['right-' + ratio]">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "two-column-layout",
  props: {
    ratio: {
      type: String,
      required: false,
      default: "70-30",
      validator: function (value) {
        return ["70-30", "50-50", "30-70"].indexOf(value) !== -1;
      }
    },
    spaceBetween: {
      type: String,
      required: false,
      default: "xs",
      validator: function (value) {
        return ["none", "xs", "s", "m", "l", "xl"].indexOf(value) !== -1;
      }
    },
  }
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.functions";
@import "../../style/abstract/abstract.spacing";

.container {
  display: flex;
  margin: 10px 0;

  @media only screen
  and (max-device-width: 768px)
  and (-webkit-min-device-pixel-ratio: 2) {
    gap: 10px;
    flex-direction: column;
    padding: 0;

    // This ensures that both div columns can
    // break out (padding, thus making it fullscreen)
    > div {
      position: relative;
      left: 50%;
      right: 50%;
      margin: 0 -50vw;
      width: 100vw;
    }
  }
}

/* Ratio sizes */
$ratioSizes:
    "70-30" 70% 30%,
    "50-50" 50% 50%,
    "30-70" 30% 70%;

@each $key, $left, $right in $ratioSizes {
  .left-#{$key} {
    width: $left;
  }

  .right-#{$key} {
    width: $right;
  }
}

/* Space between sizes */
$spacingSizes: (
    "none": 0,
    "xs": $spacing-xs,
    "s": $spacing-s,
    "m": $spacing-m,
    "l": $spacing-l,
    "xl": $spacing-xl
);

@each $size, $spacing in $spacingSizes  {
  .spacing-#{$size} {
    margin-right: rem-calc($spacing);
  }
}
</style>
